module.exports = __webpack_public_path__ + "img/sentinel-dark.34b42eef.svg";